/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { FSFBSpecialView } from './fsfbspecial-view';
import { Matrix9Struct } from './matrix9-struct';
import { PointFStruct } from './point-fstruct';
import { PointStruct } from './point-struct';
import { PointUShortStruct } from './point-ushort-struct';
import { RectStruct } from './rect-struct';
import { ViewStateAttributeProto } from './view-state-attribute-proto';

export class ViewStateProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ViewStateProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsViewStateProto(bb: flatbuffers.ByteBuffer, obj?: ViewStateProto): ViewStateProto {
    return (obj || new ViewStateProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsViewStateProto(
    bb: flatbuffers.ByteBuffer,
    obj?: ViewStateProto,
  ): ViewStateProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ViewStateProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  viewId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  specialView(): FSFBSpecialView {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : FSFBSpecialView.NONE;
  }

  viewTag(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  position(obj?: RectStruct): RectStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? (obj || new RectStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  scrollF(obj?: PointFStruct): PointFStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? (obj || new PointFStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  viewClass(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  matrix(obj?: Matrix9Struct): Matrix9Struct | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? (obj || new Matrix9Struct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  windowType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  windowFlags(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  alpha(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : 0;
  }

  url(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  inputType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  flags1(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  webViewEpoch(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  scroll(obj?: PointStruct): PointStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? (obj || new PointStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  filter(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  tintColor(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  clipmask(obj?: RectStruct): RectStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? (obj || new RectStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  customAttrs(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  customAttrsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  customAttrsArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  positionZero(obj?: PointUShortStruct): PointUShortStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? (obj || new PointUShortStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  scrollShort(obj?: PointUShortStruct): PointUShortStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? (obj || new PointUShortStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  childrenReversed(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  viewText(): number {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  fsAttributes(index: number, obj?: ViewStateAttributeProto): ViewStateAttributeProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset
      ? (obj || new ViewStateAttributeProto()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  fsAttributesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  scrollOffset(obj?: PointStruct): PointStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? (obj || new PointStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  scrollExtent(obj?: PointStruct): PointStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? (obj || new PointStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  scrollRange(obj?: PointStruct): PointStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? (obj || new PointStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  flags2(): number {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startViewStateProto(builder: flatbuffers.Builder) {
    builder.startObject(28);
  }

  static addViewId(builder: flatbuffers.Builder, viewId: number) {
    builder.addFieldInt32(0, viewId, 0);
  }

  static addSpecialView(builder: flatbuffers.Builder, specialView: FSFBSpecialView) {
    builder.addFieldInt8(1, specialView, FSFBSpecialView.NONE);
  }

  static addViewTag(builder: flatbuffers.Builder, viewTag: number) {
    builder.addFieldInt32(2, viewTag, 0);
  }

  static addPosition(builder: flatbuffers.Builder, positionOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, positionOffset, 0);
  }

  static addScrollF(builder: flatbuffers.Builder, scrollFOffset: flatbuffers.Offset) {
    builder.addFieldStruct(4, scrollFOffset, 0);
  }

  static addViewClass(builder: flatbuffers.Builder, viewClass: number) {
    builder.addFieldInt32(5, viewClass, 0);
  }

  static addMatrix(builder: flatbuffers.Builder, matrixOffset: flatbuffers.Offset) {
    builder.addFieldStruct(6, matrixOffset, 0);
  }

  static addWindowType(builder: flatbuffers.Builder, windowType: number) {
    builder.addFieldInt32(7, windowType, 0);
  }

  static addWindowFlags(builder: flatbuffers.Builder, windowFlags: number) {
    builder.addFieldInt32(8, windowFlags, 0);
  }

  static addAlpha(builder: flatbuffers.Builder, alpha: number) {
    builder.addFieldInt8(9, alpha, 0);
  }

  static addUrl(builder: flatbuffers.Builder, url: number) {
    builder.addFieldInt32(10, url, 0);
  }

  static addInputType(builder: flatbuffers.Builder, inputType: number) {
    builder.addFieldInt32(11, inputType, 0);
  }

  static addFlags1(builder: flatbuffers.Builder, flags1: number) {
    builder.addFieldInt16(12, flags1, 0);
  }

  static addWebViewEpoch(builder: flatbuffers.Builder, webViewEpoch: number) {
    builder.addFieldInt32(13, webViewEpoch, 0);
  }

  static addScroll(builder: flatbuffers.Builder, scrollOffset: flatbuffers.Offset) {
    builder.addFieldStruct(14, scrollOffset, 0);
  }

  static addFilter(builder: flatbuffers.Builder, filter: number) {
    builder.addFieldInt32(15, filter, 0);
  }

  static addTintColor(builder: flatbuffers.Builder, tintColor: number) {
    builder.addFieldInt32(16, tintColor, 0);
  }

  static addClipmask(builder: flatbuffers.Builder, clipmaskOffset: flatbuffers.Offset) {
    builder.addFieldStruct(17, clipmaskOffset, 0);
  }

  static addCustomAttrs(builder: flatbuffers.Builder, customAttrsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, customAttrsOffset, 0);
  }

  static createCustomAttrsVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createCustomAttrsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createCustomAttrsVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startCustomAttrsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addPositionZero(builder: flatbuffers.Builder, positionZeroOffset: flatbuffers.Offset) {
    builder.addFieldStruct(19, positionZeroOffset, 0);
  }

  static addScrollShort(builder: flatbuffers.Builder, scrollShortOffset: flatbuffers.Offset) {
    builder.addFieldStruct(20, scrollShortOffset, 0);
  }

  static addChildrenReversed(builder: flatbuffers.Builder, childrenReversed: boolean) {
    builder.addFieldInt8(21, +childrenReversed, +false);
  }

  static addViewText(builder: flatbuffers.Builder, viewText: number) {
    builder.addFieldInt32(22, viewText, 0);
  }

  static addFsAttributes(builder: flatbuffers.Builder, fsAttributesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(23, fsAttributesOffset, 0);
  }

  static createFsAttributesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFsAttributesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addScrollOffset(builder: flatbuffers.Builder, scrollOffsetOffset: flatbuffers.Offset) {
    builder.addFieldStruct(24, scrollOffsetOffset, 0);
  }

  static addScrollExtent(builder: flatbuffers.Builder, scrollExtentOffset: flatbuffers.Offset) {
    builder.addFieldStruct(25, scrollExtentOffset, 0);
  }

  static addScrollRange(builder: flatbuffers.Builder, scrollRangeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(26, scrollRangeOffset, 0);
  }

  static addFlags2(builder: flatbuffers.Builder, flags2: number) {
    builder.addFieldInt16(27, flags2, 0);
  }

  static endViewStateProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
